const getLeaseSlug = isLeased => (isLeased ? 'kiraye' : 'alqi-satqi');

export default getLeaseSlug;
